'use client';

import { ReactNode } from 'react';
import {
    GlowAdvancedCard,
    CardDirection,
    CardSize,
    GlowImage,
    ComposableContent,
    GlowCard,
} from '@headless-workspace/glow-ds';
import { Component, Image } from '@headless-workspace/typings';

type UIPromoBannerProps = {
    image: Image;
    title: ReactNode;
    description?: ReactNode;
    accordion?: {
        title: ReactNode;
        content: ReactNode;
    };
    href?: string;
};

const UIPromoBannerContent = ({ title, description, accordion, image }: Omit<UIPromoBannerProps, 'href'>) => (
    <div className={'flex flex-row gap-0.5'}>
        <GlowImage TagName={'img'} imgClassName={'w-[4.5rem] h-[4.5rem] flex-shrink-0 object-cover'} image={image} />
        <div className={'flex-1'}>
            <ComposableContent.Text content={title} fontSize={'bodySmall'} fontWeight={'bold'} />
            <ComposableContent.Text content={description} fontSize={'bodySmall'} TagName={'p'} />
            <ComposableContent.Accordion accordion={accordion} />
        </div>
    </div>
);

export const UIPromoBanner: Component<UIPromoBannerProps> = ({ href, title, description, accordion, image }) => {
    if (href) {
        return (
            <GlowAdvancedCard SelectableTag={'a'} href={href} size={CardSize.M} isSelected={false}>
                <UIPromoBannerContent title={title} description={description} accordion={accordion} image={image} />
            </GlowAdvancedCard>
        );
    }

    return (
        <GlowCard size={CardSize.M}>
            <UIPromoBannerContent title={title} description={description} accordion={accordion} image={image} />
        </GlowCard>
    );
};
